<template>
  <div></div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";

export default {
  name: "IdleTimer",
  data() {
    return {
      idle: false,
      idleTimer: null,
      idleFor: 0
    };
  },
  onIdle() {
    // Hook from idle-vue
    this.idle = true;
    this.triggerIdleTimer();
  },
  onActive() {
    // Hook from idle-vue
    this.idle = false;
    this.triggerIdleTimer();
  },
  mounted: function() {
    this.triggerIdleTimer();
  },
  methods: {
    ...mapActions(["ping"]),
    triggerIdleTimer() {
      this.idleFor = 0;
      clearInterval(this.idleTimer);
      const tickDuration = 60000;

      if (this.idle === true) {
        this.idleTimer = setInterval(() => {
          this.idleFor += tickDuration;

          // Logout after 120 minutes idle
          if (this.idleFor >= 120 * 60 * 1000) {
            clearInterval(this.idleTimer);
            //this.$router.push({ name: "LoggedOut" });
            Vue.prototype.$authService.logout();
          }
        }, tickDuration);
      } else {
        this.idleTimer = setInterval(() => {
          // Ping every minute when not idle
          this.ping();
        }, tickDuration);
      }
    }
  }
};
</script>

<style scoped>
aside,
div {
  display: none;
}
</style>
